module.exports = {
  __init__: [ 'overlays' ],
  overlays: [ 'type', require(51) ]
};